import { DotLottieReact } from '@lottiefiles/dotlottie-react';
import AnimatedUWLogoExtendedPurple from '@utilitywarehouse/hearth-json-assets/lib/animated-uw-logo-extended-purple-light.json';
import { BodyText } from '@utilitywarehouse/hearth-react';
import clsx from 'clsx';

import './styles.scss';

interface LoadingProps {
  className?: string;
  loadingText?: string;
}

const Loading = ({ className, loadingText }: LoadingProps) => {
  return (
    <div className={clsx('loading', className)}>
      <DotLottieReact
        data={AnimatedUWLogoExtendedPurple}
        loop
        autoplay
        className="loading__animation"
      />

      {loadingText && (
        <BodyText data-testid="loading-component" className="label">
          {loadingText}
        </BodyText>
      )}
    </div>
  );
};

export { Loading };
export type { LoadingProps };
